/* Media studio: images, edits, video, music, speech and voices, avatars, 3D, storybooks and motion
   graphics, with an asset library that keeps the AI label and Content Credentials on everything.
   API: api/src/modules/media (and the slides module's motion manifest). */
import { lazy } from 'react';
import { Palette } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'media',
  title: 'Media studio',
  short: 'Media',
  icon: Palette,
  group: 'Apps',
  route: '/media',
  order: 90,
  screen: lazy(() => import('./Screen.tsx')),
  commands: [
    { id: 'image', title: 'Media: generate an image', to: '/media?tab=image', keywords: ['picture', 'art', 'cover'] },
    { id: 'edit', title: 'Media: edit a photo', to: '/media?tab=edit', keywords: ['inpaint', 'background', 'upscale'] },
    { id: 'video', title: 'Media: make a video clip', to: '/media?tab=video', keywords: ['clip', 'timeline', 'dub'] },
    { id: 'speech', title: 'Media: read text aloud', to: '/media?tab=speech', keywords: ['voice', 'tts', 'clone'] },
    { id: 'story', title: 'Media: make a storybook', to: '/media?tab=story', keywords: ['book', 'children'] },
    { id: 'voice', title: 'Media: edit a photo by voice', to: '/media?tab=voice', keywords: ['speak', 'dictate', 'photo'] },
    { id: 'loop', title: 'Media: make a 6-second loop', to: '/media?tab=loop', keywords: ['stop motion', 'beat', 'short video'] },
  ],
  capabilities: ['MEDIA-01', 'MEDIA-02', 'MEDIA-03', 'MEDIA-04', 'MEDIA-05', 'MEDIA-07', 'MEDIA-08', 'MEDIA-09', 'MEDIA-10', 'MEDIA-11', 'MEDIA-13', 'MEDIA-14', 'MEDIA-15', 'MEDIA-16', 'MEDIA-17', 'SAFE-05'],
});
